import { FC } from "react";
import { ChequeActivityDataWithMeta, ChequeActivityUpdate } from "../types";
import {
  ActivityBody,
  ActivityBodyInfo,
  ActivityBy,
  ActivityDate,
  ActivityFooter,
  ActivityTitle,
} from "../../components";
import { addComma } from "../../../../utils";

const ChequeUpdateActivity: FC<ChequeActivityDataWithMeta> = ({
  activity,
  by,
  date,
  type,
}) => {
  const activity_ = activity as ChequeActivityUpdate;
  return (
    <>
      <ActivityTitle type={type}>ویرایش چک</ActivityTitle>
      <ActivityBody>
        <ActivityBodyInfo
          type={type}
          title="شماره چک"
          value={activity_.number}
        />
        <ActivityBodyInfo
          type={type}
          title="مبلغ"
          value={addComma(activity_.price)}
        />
      </ActivityBody>
      <ActivityFooter>
        <ActivityBy>{by}</ActivityBy>
        <ActivityDate>{date}</ActivityDate>
      </ActivityFooter>
    </>
  );
};

export default ChequeUpdateActivity;
